var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbsRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 79,
    viewBox: "0 0 1600 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_573_14251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1705.5 2.35498C1650.5 86.3555 136.5 79.3555 -26 2.35547",
    stroke: "#431C2B",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 23.3555,
    r: 9,
    transform: "rotate(90 58.5 23.3555)",
    fill: "url(#paint0_radial_573_14251)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 35.3555,
    r: 9,
    transform: "rotate(90 157.5 35.3555)",
    fill: "url(#paint1_radial_573_14251)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 43.3555,
    r: 9,
    transform: "rotate(90 249.5 43.3555)",
    fill: "url(#paint2_radial_573_14251)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 48.3555,
    r: 9,
    transform: "rotate(90 337.5 48.3555)",
    fill: "url(#paint3_radial_573_14251)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 428.5,
    cy: 53.3555,
    r: 9,
    transform: "rotate(90 428.5 53.3555)",
    fill: "url(#paint4_radial_573_14251)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 519.5,
    cy: 56.3555,
    r: 9,
    transform: "rotate(90 519.5 56.3555)",
    fill: "url(#paint5_radial_573_14251)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 608.5,
    cy: 60.3555,
    r: 9,
    transform: "rotate(90 608.5 60.3555)",
    fill: "url(#paint6_radial_573_14251)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 707.5,
    cy: 61.3555,
    r: 9,
    transform: "rotate(90 707.5 61.3555)",
    fill: "url(#paint7_radial_573_14251)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 810.5,
    cy: 62.3555,
    r: 9,
    transform: "rotate(90 810.5 62.3555)",
    fill: "url(#paint8_radial_573_14251)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 903.5,
    cy: 62.3555,
    r: 9,
    transform: "rotate(90 903.5 62.3555)",
    fill: "url(#paint9_radial_573_14251)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 992.5,
    cy: 62.3555,
    r: 9,
    transform: "rotate(90 992.5 62.3555)",
    fill: "url(#paint10_radial_573_14251)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1085.5,
    cy: 61.3555,
    r: 9,
    transform: "rotate(90 1085.5 61.3555)",
    fill: "url(#paint11_radial_573_14251)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1182.5,
    cy: 59.3555,
    r: 9,
    transform: "rotate(90 1182.5 59.3555)",
    fill: "url(#paint12_radial_573_14251)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1278.5,
    cy: 56.3555,
    r: 9,
    transform: "rotate(90 1278.5 56.3555)",
    fill: "url(#paint13_radial_573_14251)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1377.5,
    cy: 52.3555,
    r: 9,
    transform: "rotate(90 1377.5 52.3555)",
    fill: "url(#paint14_radial_573_14251)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1475.5,
    cy: 45.3555,
    r: 9,
    transform: "rotate(90 1475.5 45.3555)",
    fill: "url(#paint15_radial_573_14251)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_573_14251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1572.5,
    cy: 37.3555,
    r: 9,
    transform: "rotate(90 1572.5 37.3555)",
    fill: "url(#paint16_radial_573_14251)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_573_14251",
    x: -33.6426,
    y: 0,
    width: 1747.4,
    height: 77.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0392157 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_573_14251",
    x: 42.4243,
    y: 7.27974,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_573_14251",
    x: 141.424,
    y: 19.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_573_14251",
    x: 233.424,
    y: 27.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_573_14251",
    x: 321.424,
    y: 32.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_573_14251",
    x: 412.424,
    y: 37.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_573_14251",
    x: 503.424,
    y: 40.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_573_14251",
    x: 592.424,
    y: 44.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_573_14251",
    x: 691.424,
    y: 45.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_573_14251",
    x: 794.424,
    y: 46.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_573_14251",
    x: 887.424,
    y: 46.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_573_14251",
    x: 976.424,
    y: 46.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_573_14251",
    x: 1069.42,
    y: 45.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_573_14251",
    x: 1166.42,
    y: 43.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_573_14251",
    x: 1262.42,
    y: 40.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_573_14251",
    x: 1361.42,
    y: 36.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_573_14251",
    x: 1459.42,
    y: 29.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_573_14251",
    x: 1556.42,
    y: 21.2797,
    width: 32.1515,
    height: 32.1515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41515,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83029
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.8719 0 0 0 0 0.437275 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_14251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_14251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5 23.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.5 35.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.5 43.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(337.5 48.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(428.5 53.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(519.5 56.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(608.5 60.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(707.5 61.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(810.5 62.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(903.5 62.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(992.5 62.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1085.5 61.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1182.5 59.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1278.5 56.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1377.5 52.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1475.5 45.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_573_14251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1572.5 37.3555) rotate(90) scale(10.9286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC709"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbsRow);
export default __webpack_public_path__ + "static/media/lightbulbs-row.f72a81935876068baf4a0aa429b3cb7a.svg";
export { ForwardRef as ReactComponent };